import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import { isAfter, isBefore } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine, faSquare, faTasks } from "@fortawesome/pro-duotone-svg-icons";
import { Box, Grid, LinearProgress, List, ListItem } from "@material-ui/core";
import { Chart } from "primereact/chart";
const ProcessedRequestsPanel = ({ startDate, endDate, requests, locationView, colorMode }) => {
    const brands = useSelector((state) => state.brands.untouchedlist);
    const [chartData, setChartData] = useState({});
    const [perBrandRequests, setPerBrandRequests] = useState([]);
    const [pendingRequests, setPendingRequests] = useState([]);
    const [approvedRequests, setApprovedRequests] = useState([]);
    const [cancelledRequests, setCancelledRequests] = useState([]);
    const [palette, setPalette] = useState([]);
    useEffect(() => {
        if (requests && brands) {
            let _requests = _.compact(
                _.map(requests, (request, i) => {
                    const _reqDate = new Date(request.request_date);
                    if (isAfter(_reqDate, startDate) && isBefore(_reqDate, endDate)) {
                        return request;
                    }
                })
            );
            let _grpdBy = _.groupBy(_requests, "status");
            let _pendingRequests = _grpdBy["Pending"];
            let _approvedRequests = _grpdBy["Approved"];
            let _cancelledRequests = _grpdBy["Cancelled"];
            let _perbrandrequests = _.compact(
                _.map(brands, (brand, i) => {
                    if (brand.active) {
                        let _brdrequests = _.compact(
                            _.map(_requests, (request, i) => {
                                let _asscbrndarry;
                                if (Array.isArray(request.assocBrands)) {
                                    // console.log("an array");
                                    _asscbrndarry = request.assocBrands;
                                } else {
                                    _asscbrndarry = _.compact(request.assocBrands.split(";"));
                                }
                                if (_.includes(_asscbrndarry, brand.slug) && request.location === brand.location) {
                                    return request;
                                }
                            })
                        );
                        let brdObj = {
                            brand: brand.name,
                            slug: brand.slug,
                            location: brand.location,
                            color: brand.hexcolor,
                            val: _brdrequests.length,
                        };
                        if (_brdrequests.length >= 1) {
                            return brdObj;
                        }
                    }
                })
            );
            let _paletteColors = _.compact(
                _.map(_perbrandrequests, (brand, i) => {
                    if (brand.location === locationView) {
                        return brand.color;
                    }
                })
            );
            setPalette(_paletteColors);
            let _perbrandpendingrequests = _.compact(
                _.map(brands, (brand, i) => {
                    if (brand.active) {
                        let _brdrequests = _.compact(
                            _.map(_pendingRequests, (request, i) => {
                                let _asscbrndarry;
                                if (Array.isArray(request.assocBrands)) {
                                    // console.log("an array");
                                    _asscbrndarry = request.assocBrands;
                                } else {
                                    _asscbrndarry = _.compact(request.assocBrands.split(";"));
                                }
                                if (_.includes(_asscbrndarry, brand.slug) && request.location === brand.location) {
                                    return request;
                                }
                            })
                        );
                        let brdObj = {
                            brand: brand.name,
                            slug: brand.slug,
                            location: brand.location,
                            color: brand.hexcolor,
                            val: _brdrequests.length,
                        };
                        if (_brdrequests.length >= 1) {
                            return brdObj;
                        }
                    }
                })
            );
            let _perbrandapprovedrequests = _.compact(
                _.map(brands, (brand, i) => {
                    if (brand.active) {
                        let _brdrequests = _.compact(
                            _.map(_approvedRequests, (request, i) => {
                                let _asscbrndarry;
                                if (Array.isArray(request.assocBrands)) {
                                    // console.log("an array");
                                    _asscbrndarry = request.assocBrands;
                                } else {
                                    _asscbrndarry = _.compact(request.assocBrands.split(";"));
                                }
                                if (_.includes(_asscbrndarry, brand.slug) && request.location === brand.location) {
                                    return request;
                                }
                            })
                        );
                        let brdObj = {
                            brand: brand.name,
                            slug: brand.slug,
                            location: brand.location,
                            color: brand.hexcolor,
                            val: _brdrequests.length,
                        };
                        if (_brdrequests.length >= 1) {
                            return brdObj;
                        }
                    }
                })
            );
            let _perbrandcancelledrequests = _.compact(
                _.map(brands, (brand, i) => {
                    if (brand.active) {
                        let _brdrequests = _.compact(
                            _.map(_cancelledRequests, (request, i) => {
                                let _asscbrndarry;
                                if (Array.isArray(request.assocBrands)) {
                                    // console.log("an array");
                                    _asscbrndarry = request.assocBrands;
                                } else {
                                    _asscbrndarry = _.compact(request.assocBrands.split(";"));
                                }
                                if (_.includes(_asscbrndarry, brand.slug) && request.location === brand.location) {
                                    return request;
                                }
                            })
                        );
                        let brdObj = {
                            brand: brand.name,
                            slug: brand.slug,
                            location: brand.location,
                            color: brand.hexcolor,
                            val: _brdrequests.length,
                        };
                        if (_brdrequests.length >= 1) {
                            return brdObj;
                        }
                    }
                })
            );
            // console.log(_perbrandpendingrequests);
            setPendingRequests(_perbrandpendingrequests);
            setApprovedRequests(_perbrandapprovedrequests);
            setCancelledRequests(_perbrandcancelledrequests);
            setPerBrandRequests(_perbrandrequests);
        }
    }, [startDate, endDate, requests, brands]);
    useEffect(() => {
        if (locationView) {
            let _chartData = {
                labels: ["Pending", "Approved", "Cancelled"],
                datasets: _.compact(
                    _.map(brands, (brand, i) => {
                        if (brand.active && brand.location === locationView) {
                            let _pendingVal = _.find(pendingRequests, { slug: brand.slug, location: locationView });
                            let _approvedVal = _.find(approvedRequests, { slug: brand.slug, location: locationView });
                            let _cancelledVal = _.find(cancelledRequests, { slug: brand.slug, location: locationView });
                            let _branddataset = {
                                type: "bar",
                                label: brand.name,
                                data: [_pendingVal ? _pendingVal.val : 0, _approvedVal ? _approvedVal.val : 0, _cancelledVal ? _cancelledVal.val : 0],
                                fill: true,
                                backgroundColor: brand.hexcolor,
                            };
                            return _branddataset;
                        }
                    })
                ),
            };
            setChartData(_chartData);
        }
    }, [locationView, palette, perBrandRequests]);

    let chartOptions = {
        tooltips: {
            mode: "index",
            intersect: false,
        },
        scales: {
            xAxes: [
                {
                    stacked: true,
                    ticks: {
                        fontColor: colorMode === "light" ? "#495057" : "#ffffff",
                    },
                    gridLines: {
                        color: colorMode === "light" ? "#495057" : "#9e9e9e",
                    },
                },
            ],
            yAxes: [
                {
                    stacked: true,
                    ticks: {
                        fontColor: colorMode === "light" ? "#495057" : "#ffffff",
                    },
                    gridLines: {
                        color: colorMode === "light" ? "#495057" : "#9e9e9e",
                    },
                },
            ],
        },
        legend: {
            display: false,
        },
    };
    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Box p={2}>
                        <FontAwesomeIcon icon={faChartLine} fixedWidth size='2x' />
                        &nbsp;
                        <span style={{ fontSize: "1.4rem", textTransform: "uppercase" }}>Processed Requests</span>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Box p={2}>{!_.isEmpty(perBrandRequests) ? <Chart type='bar' data={chartData} options={chartOptions} /> : "No Records to view"}</Box>
                </Grid>
            </Grid>
        </>
    );
};

export default ProcessedRequestsPanel;
